import { HttpContextToken } from '@angular/common/http';

export const HANDLE_ERRORS_IN_COMPONENT: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
